import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "close-icon",
	width: 25,
	height: 25,
	viewBox: "0 0 32 32",
	role: "img",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7 25L25 7M25 25L7 7",
		strokeWidth: 2,
		stroke: "#000"
	})]
});
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
